export const getTagColor = (badge) => {
  if (!badge) {
    return ''
  }

  if (badge === 'BEST PRICE GUARANTEED') {
    return 'utility-positive-12'
  }

  if (badge === 'NEW') {
    return 'utility-danger-20'
  }

  if (badge === 'TOP SELLING') {
    return 'utility-attention-12'
  }

  if (badge === '3D PRINT VERIFIED') {
    return 'brand-primary-10'
  }

  if (badge === 'TOP RATED') {
    return 'misc-primary-12'
  }

  if (badge === 'AI GENERATED') {
    return 'grey-6'
  }

  if (badge === 'DESIGNER\'S PICK') {
    return 'cgtrader-16'
  }

  return ''
}
